import React, { useState } from "react";
import { useNavigate } from "react-router";
import "./VendorRegistration.css";
import { useDispatch } from "react-redux";
import LoginOtp from "../Login/LoginOtp";
import { isValidPhoneNumber } from "libphonenumber-js";
const { VendorRegister } = require("../../../context/Slice/RegisterSlice");

const VendorRegistration = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState("");
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState("IN");

  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [input, setInput] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    mobile_number: "",
  });

  const alphabetRegex = /^[A-Za-z]+$/;

  const handleSubmit = async (event) => {
    event.preventDefault();
    const passwordRegex = /^.{8,}$/;
    const mobileRegex = /^[0-9]{10}$/;
        if (!passwordRegex.test(input.password)) {
          // alert("Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one digit, and one special character.");
          alert("Password must be at least 8 characters long.");
          return;
        }
        if (!isValidPhoneNumber(input.mobile_number, selectedCountry)) {
          alert("Please enter a valid mobile number.");
          return;
        }
        // if (!mobileRegex.test(input.mobile_number)) {
        //   alert("Mobile number must be 10 digits.");
        //   return;
        // }
        if (!termsAccepted) {
          alert("You must agree to the Terms of Service.");
          return;
        }
    const response = await dispatch(VendorRegister(input));
    if (response.payload.status === 200) {
      setEmail({ email: input.email });
      setIsOpen(true);
      // navigate("/Verify-Otp", { state: { email: input.email } });
    } else {
      console.log("something wrong");
    }
  };

  return (
    <div id="VendorRegistermaindiv">
      {!isOpen ? (
        <section id="vendor-registration" className="user-reg">
          <div className="container py-5 py-sm-5 py-xl-5 h-100 user-registration-container">
            <div className="row d-flex h-100">
              <div className="col">
                <div className="card card-registration registration-container">
                  <div className="row g-0">
                    <div className="col-xl-6 col-md-6 d-sm-block image-box">
                      <img
                        src="assets/Images/about-1.jpg"
                        alt="Sample photo"
                        className="img-fluid"
                      />
                    </div>
                    <div className="col-xl-6 col-md-6 mt-5">
                      <div className="card-body text-black">
                        <h3 className="mb-5 text-uppercase heading-signUp">
                          Vendor Sign Up
                        </h3>
                        <div className="coloum">
                          <form autoComplete="off" onSubmit={handleSubmit}>
                            <div className="form-outline mb-4">
                              <label className="form-label" htmlFor="firstName">
                                First Name
                              </label>
                              <input
                                type="text"
                                id="firstName"
                                name="firstName"
                                value={input.firstName}
                                required
                                onChange={(event) => {
                                  const value = event.target.value;
                                  if (alphabetRegex.test(value) || value === "") {
                                    setInput({
                                      ...input,
                                      firstName: value,
                                    });
                                  }
                                }}
                                className="form-control form-control-lg"
                              />
                            </div>
                            <div className="form-outline mb-4">
                              <label className="form-label" htmlFor="lastName">
                                Last Name
                              </label>
                              <input
                                type="text"
                                id="lastName"
                                name="lastName"
                                value={input.lastName}
                                required
                                onChange={(event) => {
                                  const value = event.target.value;
                                  if (alphabetRegex.test(value) || value === "") {
                                    setInput({
                                      ...input,
                                      lastName: value,
                                    });
                                  }
                                }}
                                className="form-control form-control-lg"
                              />
                            </div>
                            <div className="form-outline mb-4">
                              <label className="form-label" htmlFor="email">
                                Your Email
                              </label>
                              <input
                                type="email"
                                id="email"
                                name="email"
                                value={input.email}
                                required
                                onChange={(event) =>
                                  setInput({
                                    ...input,
                                    email: event.target.value,
                                  })
                                }
                                className="form-control form-control-lg"
                              />
                            </div>
                            <div className="form-outline mb-4">
                              <label className="form-label" htmlFor="password">
                                Password
                              </label>
                              <input
                                type="password"
                                id="password"
                                name="password"
                                value={input.password}
                                required
                                onChange={(event) =>
                                  setInput({
                                    ...input,
                                    password: event.target.value,
                                  })
                                }
                                className="form-control form-control-lg"
                              />
                            </div>
                            <div className="form-outline mb-4">
                              <label
                                className="form-label"
                                htmlFor="mobile_number"
                              >
                                Mobile Number
                              </label>
                              <input
                                type="text"
                                id="mobile_number"
                                name="mobile_number"
                                value={input.mobile_number}
                                required
                                onChange={(event) =>
                                  setInput({
                                    ...input,
                                    mobile_number: event.target.value,
                                  })
                                }
                                className="form-control form-control-lg"
                              />
                            </div>
                            <div className="form-check d-flex justify-content-center mb-5">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                                value=""
                                id="form2Example3cg"
                                checked={termsAccepted}
                                onChange={(e) => setTermsAccepted(e.target.checked)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="form2Example3cg"
                              >
                                I agree to all statements in{" "}
                                <a href="#!" className="text-body">
                                  <u>Terms of service</u>
                                </a>
                              </label>
                            </div>
                            <div className="d-flex justify-content-center">
                              <button
                                type="submit"
                                className="btn btn-success btn-block btn-lg gradient-custom-4 text-body"
                              >
                                Register
                              </button>
                            </div>
                            <p className="text-center text-muted mt-5 mb-0 para-text">
                              Have already an account?{" "}
                              <a
                                href="#!"
                                className="fw-bold text-body link-text"
                              >
                                <u onClick={() => navigate("/login")}>
                                  Login here
                                </u>
                              </a>
                            </p>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <LoginOtp email={email} />
      )}
    </div>
  );
};

export default VendorRegistration;
